/**
 * @generated SignedSource<<9f15763135896cfb2d51406dd84b2a26>>
 * @relayHash 9d0533890762d730a9350f01835deb68
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b16f23a7b1e6ccac95bdbff4b38bfaf94ee7be8cd69983257c0caf95ac7f0b60

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraBatchWindowPreference = "DEFAULT_BATCHING" | "FIFTEEN_MINUTES" | "FIVE_MINUTES" | "NO_BATCHING" | "ONCE_PER_DAY" | "ONE_DAY" | "ONE_HOUR" | "TEN_MINUTES" | "THIRTY_MINUTES" | "%future added value";
export type JiraEmailMimeType = "HTML" | "TEXT" | "%future added value";
export type JiraUpdateNotificationOptionsInput = {
  batchWindow?: JiraBatchWindowPreference | null | undefined;
  dailyBatchLocalTime?: string | null | undefined;
  emailMimeType?: JiraEmailMimeType | null | undefined;
  isEmailNotificationEnabled?: boolean | null | undefined;
  notifyOwnChangesEnabled?: boolean | null | undefined;
  notifyWhenRoleAssigneeEnabled?: boolean | null | undefined;
  notifyWhenRoleReporterEnabled?: boolean | null | undefined;
};
export type batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceFieldMutation$variables = {
  cloudId: string;
  input: JiraUpdateNotificationOptionsInput;
};
export type batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceFieldMutation$data = {
  readonly jira: {
    readonly updateGlobalNotificationOptions: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly options: {
        readonly " $fragmentSpreads": FragmentRefs<"batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceField">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceFieldMutation = {
  response: batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceFieldMutation$data;
  variables: batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceFieldMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceFieldMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateNotificationOptionsPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationOptions",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationOptions",
                "kind": "LinkedField",
                "name": "options",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceField"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceFieldMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateNotificationOptionsPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationOptions",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationOptions",
                "kind": "LinkedField",
                "name": "options",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "dailyBatchLocalTime"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "batchWindow"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b16f23a7b1e6ccac95bdbff4b38bfaf94ee7be8cd69983257c0caf95ac7f0b60",
    "metadata": {},
    "name": "batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceFieldMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "86d3b2d15625f4fa9ccb4a97247580ee";

export default node;
